/* globals angular */
( function () {
	'use strict';
	/* eslint-disable max-params */
	function GenerateWarehouseExportReport ( $q, warehouseExportFactory, reportTemplatesFactory, logger, reportService ) {
		/* eslint-enable max-params */
		var self = this;

		self.templateTitle = 'Observation Data Warehouse Report';

		function processFetchedTemplates ( data ) {
			reportTemplatesFactory.storeFetchedTemplates( data );
			self.allObsTemplates = reportTemplatesFactory.getFilteredTemplates( data );
		}

		function stopLoading () {
			self.hasData = true;
		}

		function stopExporting () {
			self.exporting = false;
		}

		function activate () {
			self.selectedTemplate = undefined;
			self.allObsTemplates  = [];

			$q.all( [
				warehouseExportFactory.fetchTemplates().then( processFetchedTemplates )
				// add this when we publish to the reports page
				// reportService.getReportDetails( getReportDetails )
			] ).finally( stopLoading );
		}

		function generateReport () {
			var errorMessage = 'Please select a template.';

			// self.exportDataMax = 0;

			if ( self.selectedTemplate ) {
				self.exporting = true;
				warehouseExportFactory.fetchObservationCSVExport( self.selectedTemplate.id ).then( function ( response ) {
					var filename = 'obs_for_template_' + self.selectedTemplate.id;
					var blob     = new Blob( [ response.data ], { 'type' : 'text/csv' } );

					if ( window.navigator.msSaveOrOpenBlob ) {
						window.navigator.msSaveBlob( blob, filename );
					} else {
						var elem = window.document.createElement( 'a' );

						elem.href     = window.URL.createObjectURL( blob );
						elem.download = filename;
						document.body.appendChild( elem );
						elem.click();
						document.body.removeChild( elem );
					}
				} ).finally( stopExporting );
			} else {
				self.showTable = false;
				logger.notifyError( errorMessage );
			}
		}

		activate();

		self.generateReport = generateReport;
		self.hasPdfMake     = reportService.hasPdfMake;
	}

	GenerateWarehouseExportReport.$inject = [ '$q', 'warehouseExportFactory', 'reportTemplatesFactory', 'logger', 'reportService' ];

	angular
		.module( 'app.report' )
		.controller( 'GenerateWarehouseExportReport', GenerateWarehouseExportReport );
} )();
